module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAXCAYAAADtNKTnAAABRElEQVQ4jcXUP0gcQRzF8c/JIlgkR8BKRGyskiLYRSwsvMMyHNrYxSYhVSIeBBuxPbFSUOxOsAoIktiIIGIX8FKkSJoUCaQJFtoopLLY8Q/L7t7tpfA1b5d5+903w48pNZtNKZrAO7xAGb+whwbOkuGexHsJqzhCFV+xiyvU8R1j7SDvMY9PGMIUZvEclZDZx2AW5DGW0MJ0Su1D1ML2FrMglQBq4F+yctAJjjGTBRkJfpoBuFEL/XiSBikHz2ohsf4oDdKp/ojb3v4sCj6K4fA8jr85kB/4gGcYQCvCBt7cC+0UbLYZYQ4HWCn4MfEAvorQi5/iOSiqGqrtDnYZl1jPC7WDLKAPb8WNu4JsB/8oZ37aQT4H38sLdTNsDwP5htf4kheK8hbxG1v/26QjRTjHS3f3SRE9xUUkvtXXMNkF5Bz1awH4N+hXW6+dAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/10.png
// module id = N3PI
// module chunks = 188